import { InfoBox } from '@dealstack/frontend/shared/components/InfoBox/InfoBox.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { MipInvestorBankAccountDataGapRes } from '@dealstack/shared/lib/generated';
import { List } from '@mantine/core';

interface Props {
	dataGaps: MipInvestorBankAccountDataGapRes[];
}

// Orange, not red: a gap is a check that could not run, not a finding against the account.
export const DataGapsCallout = ({ dataGaps }: Props) => {
	const tMipManage = useTranslationMipManage();

	if (dataGaps.length === 0) {
		return null;
	}

	return (
		<InfoBox
			direction="row"
			iconVariant="warning"
			rippleColor="orange"
			matchBorderToRippleColor
			title={tMipManage('bank_accounts.details.data_gaps.title', {
				count: dataGaps.length,
			})}
			dataTestId={TEST_ELEMENT_IDS.MIP_MANAGE_BANK_ACCOUNT_DATA_GAP_CALLOUT}
		>
			<List
				c="dark.8"
				listStyleType="disc"
				withPadding
				style={{ paddingInlineStart: '0.5rem' }}
			>
				{dataGaps.map((gap) => (
					<List.Item key={gap.key}>{gap.message}</List.Item>
				))}
			</List>
		</InfoBox>
	);
};
